import './ScopeDisplaySelector.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Radio } from 'antd';
import React from 'react';
import { DensityComfortableIcon, DensityCompactIcon } from '@ui/icons';

export type ScopeDisplayType = 'comfortable' | 'compact';

export interface ScopeDisplaySelectorProps {
	onChange: (value: ScopeDisplayType) => void;
	value: ScopeDisplayType;
}

export const ScopeDisplaySelector: React.FC<ScopeDisplaySelectorProps> = ({ onChange, value }) =>
	<div className='scope-display-selector'>
		<span>{ COPY_SPECIFIC.VIEW }</span>
		<Radio.Group
			buttonStyle='solid'
			defaultValue='comfortable'
			onChange={ (e) => onChange(e.target.value as ScopeDisplayType) }
			options={ [
				{
					label: <DensityComfortableIcon />,
					value: 'comfortable'
				},
				{
					label: <DensityCompactIcon />,
					value: 'compact'
				}
			] }
			optionType='button'
			value={ value } />
	</div>;

